module.exports = __webpack_public_path__ + "static/media/icon-renew-account.312c9d28.svg";